/* ==========================================================================
   Oates Product Page interactions (v80)
   - Gallery: click / keyboard-activate thumbnails to swap main image
   - Variants: switching selects updates:
       * hidden [name="id"] variant input
       * displayed price (.product-pricing__current)
       * ATC label ([data-atc-label] & data-atc-label-default)
       * data-product-base-price (used by companions bundle total)
       * available/sold-out state on ATC button
       * URL ?variant=... (history.replaceState)
       * Main gallery image if variant has featured_image
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Gallery (v104: full video support) ---------------- */
  function initGallery() {
    var mainImg   = document.getElementById('gallery-main-img');
    var mainVideo = document.getElementById('gallery-main-video');
    var thumbs    = document.querySelectorAll('.gallery__thumb');
    if (!mainImg || thumbs.length === 0) return;

    function clearVideo() {
      if (!mainVideo) return;
      mainVideo.innerHTML = '';
      mainVideo.hidden = true;
      mainVideo.setAttribute('aria-hidden', 'true');
    }

    function showImage(url, alt) {
      clearVideo();
      mainImg.hidden = false;
      mainImg.setAttribute('src', url);
      if (alt) mainImg.setAttribute('alt', alt);
    }

    function showMp4(src, poster, alt) {
      if (!mainVideo) { showImage(poster || src, alt); return; }
      mainImg.hidden = true;
      mainVideo.hidden = false;
      mainVideo.setAttribute('aria-hidden', 'false');
      mainVideo.innerHTML =
        '<video class="gallery__video-el" controls playsinline preload="metadata" ' +
        'poster="' + (poster || '') + '" ' +
        'aria-label="' + (alt || 'Product video') + '">' +
        '  <source src="' + src + '" type="video/mp4">' +
        '  Your browser does not support the video tag.' +
        '</video>';
      var v = mainVideo.querySelector('video');
      if (v) {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function(){});
      }
    }

    function showYouTube(id, alt) {
      if (!mainVideo) return;
      mainImg.hidden = true;
      mainVideo.hidden = false;
      mainVideo.setAttribute('aria-hidden', 'false');
      mainVideo.innerHTML =
        '<iframe class="gallery__video-el" ' +
        'src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1" ' +
        'title="' + (alt || 'Product video') + '" ' +
        'frameborder="0" allowfullscreen ' +
        'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>';
    }

    function activate(thumb) {
      var alt = thumb.getAttribute('data-alt') || '';
      var type = thumb.getAttribute('data-media-type') || '';
      var poster = thumb.getAttribute('data-img') || '';

      if (type === 'video') {
        var src = thumb.getAttribute('data-video-src');
        if (src) { showMp4(src, poster, alt); }
        else { showImage(poster, alt); }
      } else if (type === 'external_video') {
        var extId = thumb.getAttribute('data-video-external-id');
        var host = thumb.getAttribute('data-video-host');
        if (extId && host === 'youtube') { showYouTube(extId, alt); }
        else { showImage(poster, alt); }
      } else {
        showImage(poster, alt);
      }

      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { activate(thumb); });
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(thumb);
        }
      });
    });

    // Public helper for variant swap
    window.__oatesGalleryShowSrc = function (srcUrl, altText) {
      if (!srcUrl) return;
      clearVideo();
      mainImg.hidden = false;
      mainImg.setAttribute('src', srcUrl);
      if (altText) mainImg.setAttribute('alt', altText);
      var matched = false;
      thumbs.forEach(function (t) {
        if (t.getAttribute('data-img') === srcUrl && (t.getAttribute('data-media-type') || '') === '') {
          t.classList.add('active');
          matched = true;
        } else {
          t.classList.remove('active');
        }
      });
      if (!matched && thumbs[0]) thumbs[0].classList.add('active');
    };
  }

  /* ---------------- Variant switching ---------------- */
  function initVariants() {
    var dataEl = document.getElementById('oates-product-json');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('[oates-product] product JSON parse failed', e); return; }
    if (!product || !product.variants || product.variants.length === 0) return;

    var selects = document.querySelectorAll('.product-variant-group__select');
    if (selects.length === 0) return;

    var form    = document.getElementById('product-form');
    var hiddenId = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = document.querySelector('.product-pricing__current');
    var atcBtn  = document.getElementById('ProductAddToCart');
    var atcLbl  = document.querySelector('[data-atc-label]');
    var stickyBtn = document.getElementById('StickyAddToCart');
    var stickyLbl = stickyBtn ? stickyBtn.querySelector('[data-sticky-atc-label]') : null;

    // Money formatting — mirror the shop's default "$X.XX USD" pattern for USD.
    // Prefers Shopify.formatMoney if theme has it available.
    function money(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      var n = (cents || 0) / 100;
      return '$' + n.toFixed(2);
    }

    function currentOptionValues() {
      return Array.prototype.map.call(selects, function (sel) { return sel.value; });
    }

    function findVariant(vals) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var opts = v.options;
        var match = true;
        for (var j = 0; j < vals.length; j++) {
          if (opts[j] !== vals[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateForVariant(variant) {
      if (!variant) {
        // Unavailable combination
        if (atcBtn) {
          atcBtn.setAttribute('disabled', 'disabled');
          if (atcLbl) atcLbl.textContent = 'Unavailable';
        }
        if (stickyBtn) stickyBtn.setAttribute('disabled', 'disabled');
        if (stickyLbl) stickyLbl.textContent = 'Unavailable';
        return;
      }

      // Hidden variant ID
      if (hiddenId) hiddenId.value = variant.id;

      // Price display
      if (priceEl) {
        priceEl.setAttribute('aria-label', 'Price: ' + money(variant.price));
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<span class="product-pricing__sale">' + money(variant.price) + '</span> ' +
            '<span class="product-pricing__compare"><s>' + money(variant.compare_at_price) + '</s></span>';
        } else {
          priceEl.textContent = money(variant.price);
        }
      }

      // ATC button state + label
      if (atcBtn) {
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          var newLbl = 'Add to Cart — ' + money(variant.price);
          if (atcLbl) atcLbl.textContent = newLbl;
          atcBtn.setAttribute('data-atc-label-default', newLbl);
          atcBtn.setAttribute('data-product-base-price', variant.price);
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          if (atcLbl) atcLbl.textContent = 'Sold Out';
        }
      }
      if (stickyBtn) {
        if (variant.available) {
          stickyBtn.removeAttribute('disabled');
          if (stickyLbl) stickyLbl.textContent = 'Add to Cart — ' + money(variant.price);
        } else {
          stickyBtn.setAttribute('disabled', 'disabled');
          if (stickyLbl) stickyLbl.textContent = 'Sold Out';
        }
      }

      // Update URL ?variant= without reload
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* older browsers — ignore */ }

      // Swap gallery to variant's featured image if it exists
      if (variant.featured_image && variant.featured_image.src && window.__oatesGalleryShowSrc) {
        var src = variant.featured_image.src;
        // Shopify variant featured_image.src is often protocol-relative or already full.
        if (src.indexOf('//') === 0) src = 'https:' + src;
        // Request a 1200-wide version like the main gallery does. Shopify supports width param.
        try {
          var u = new URL(src, window.location.origin);
          if (!/_(\d+x\d*)\./.test(u.pathname)) {
            // Add width via query if we can't do the _1200x. filename trick.
            u.searchParams.set('width', '1200');
          }
          src = u.toString();
        } catch (e) { /* keep original */ }
        window.__oatesGalleryShowSrc(src, variant.featured_image.alt || product.title);
      }

      // Fire a synthetic event other scripts (e.g. companions) can hook if needed
      document.dispatchEvent(new CustomEvent('oates:variant:change', {
        detail: { variant: variant, product: product }
      }));
    }

    function onSelectChange() {
      var vals = currentOptionValues();
      var v = findVariant(vals);
      updateForVariant(v);
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', onSelectChange);
    });

    // Fire once on load so initial state matches the selected values (handles
    // deep-links with ?variant=... where the selects were pre-selected server-side)
    onSelectChange();
  }

  /* ---------------- Quantity +/- ---------------- */
  function initQuantity() {
    var input = document.getElementById('qty-value');
    var minus = document.getElementById('qty-minus');
    var plus  = document.getElementById('qty-plus');
    if (!input || (!minus && !plus)) return;

    function readMin() {
      var m = parseInt(input.getAttribute('min'), 10);
      return isNaN(m) ? 1 : m;
    }
    function readMax() {
      var m = parseInt(input.getAttribute('max'), 10);
      return isNaN(m) ? Infinity : m;
    }
    function readStep() {
      var s = parseInt(input.getAttribute('step'), 10);
      return isNaN(s) || s < 1 ? 1 : s;
    }
    function currentVal() {
      var v = parseInt(input.value, 10);
      return isNaN(v) ? readMin() : v;
    }
    function setVal(v) {
      var min = readMin();
      var max = readMax();
      if (v < min) v = min;
      if (v > max) v = max;
      input.value = v;
      // Fire a change event so any other listener (e.g. companions total) recalculates.
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input',  { bubbles: true }));
    }

    if (minus) {
      minus.addEventListener('click', function (e) {
        e.preventDefault();
        setVal(currentVal() - readStep());
      });
    }
    if (plus) {
      plus.addEventListener('click', function (e) {
        e.preventDefault();
        setVal(currentVal() + readStep());
      });
    }
    // Guard: clamp on manual typing/blur
    input.addEventListener('blur', function () {
      setVal(currentVal());
    });
  }

  function init() {
    initGallery();
    initVariants();
    initQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
